<template>
  <span
    class="icon"
    :class="size"
  >
    <i :class="[pack, `fa-${icon}`, customClass]"/>
  </span>
</template>

<script setup lang="ts">
  /** Font Awesome icon in a Bulma icon container (the markup the Buefy icon produced). */
  withDefaults(defineProps<{
    icon: string;
    pack?: string;
    size?: string;
    customClass?: string;
  }>(), {
    pack: 'fas',
    size: undefined,
    customClass: undefined,
  });
</script>
